import { render, staticRenderFns } from "./skeleton.vue?vue&type=template&id=2bd43c6d&scoped=true&"
import script from "./skeleton.vue?vue&type=script&lang=js&"
export * from "./skeleton.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/global.less?vue&type=style&index=0&id=2bd43c6d&lang=less&scoped=true&"
import style1 from "./skeleton.vue?vue&type=style&index=1&id=2bd43c6d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd43c6d",
  null
  
)

component.options.__file = "skeleton.vue"
export default component.exports